import React, {Fragment, useEffect} from "react";

// for styles
import {
  // Button,
  Backdrop
} from "@material-ui/core/";

// sass
import "../../scss/common.scss";
import "../../scss/component.scss";

import Modal from "@material-ui/core/Modal";
import {PlanSelectFormData} from "../../types/planSelectForm";
// import {roomData} from "../../types/Hotel";
import {PlanSearch} from "../../types/Search";
import { useTranslation } from "react-i18next";
import { LANGUAGES } from "../../constants/languages";

// モーダルに何か渡したい場合はここ追加する
type Props = {
  isShow: boolean,
  planSelectFormData: PlanSelectFormData,
  callback: () => void,
}

const NumberOfPeopleModal: React.FC<Props> = ({
  isShow,
  planSelectFormData,
  callback
}) => {

  const { t, i18n } = useTranslation();
  
  const [rooms, setRooms] = React.useState<PlanSearch["roomDetail"]>();
  
  useEffect(() => {
    if (planSelectFormData.searchParams !== undefined) {
      const roomData = planSelectFormData.searchParams.roomDetail;
      setRooms(roomData);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  return (
    <>
    <div>
      <Modal
        open={isShow}
        onClose={callback}
        className="modal-simple"
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 300,
        }}
      >
        <div className="modal-simple-content pt-0 pb-0">
          <div className="modal-simple-content-close">
            <button className="button-clear" onClick={callback}>
              <i className="icon-modal-close-navy fz-30"></i>
            </button>
          </div>
          <div className="box-separate">

            {rooms !== undefined ?
              <>
                {rooms.map((room, rIndex) => (
                  <div key={rIndex} className="box-separate-item">
                    <div className="box-separate-item-block">
                      <p className="fz-16 fw-b c-navy mb-8">{rIndex + 1}部屋目</p>
                      <div>
                        <dl className="d-f mb-8">
                          {/* <dt className="w-80 pr-16 fz-14">成人{room.adult}名</dt> */}
                          <dt className="w-80 pr-16 fz-14">{t("Common.大人")}{room.adult}{t("Common.名")}</dt>
                          <dd></dd>
                        </dl>
                        {room.child.length > 0 ?
                          <>
                            <dl className="d-f">
                              {/* <dt className="w-80 pr-16 fz-14">兒童{room.child.length}名</dt> */}
                              <dt className="w-80 pr-16 fz-14">{t("Common.子供")}{room.child.length}{t("Common.名")}</dt>
                              <dd className="fz-14">
                                {room.child.map((child, cIndex) => (
                                  <Fragment key={cIndex}>
                                    {/* {cIndex + 1}人目：{child.age}歲<br /> */}
                                    {
                                      i18n.language === LANGUAGES.JA ? (
                                        <>{cIndex + 1}人目：{child.age}歳<br /></>
                                      ) : i18n.language === LANGUAGES.EN ? (
                                        <>Guest {cIndex + 1}：Age {child.age}<br /></>
                                      ) : (
                                        <>第{cIndex + 1}人：{child.age}歲<br /></>
                                      )
                                    }
                                  </Fragment>
                                ))}
                              </dd>
                            </dl>
                          </>:<></>
                        }
                      </div>
                    </div>
                  </div>
                  ))}
              </>:<></>
            }

            <div className="box-separate-item">
              <div className="box-separate-item-block small">
                {/* <p className="mb-24 fz-12 c-red ta-r">房間分配不能更改。</p> */}
                <p className="mb-24 fz-12 c-red ta-r">{t("NumberOfPeopleModal.※部屋割は変更できません。")}</p>
                <p className="ta-r">
                  <button onClick={callback} className="button-medium-light_blue w-60">
                  OK
                  </button>
                </p>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
    </>
  );
};

export default NumberOfPeopleModal;
